var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "vue-smart-slider-mark",
      style: { left: _vm.markPosition.toString().concat("%") },
    },
    [
      _c("div", { staticClass: "vue-smart-slider-mark-label" }, [
        _vm._v("\n    " + _vm._s(_vm.propMark.label) + "\n  "),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }